// ページの外枠カード（白い角丸・枠線・影・余白）。スマホ幅（sm 未満）では外して全幅にし、
// 中のカードを一番外のカードとして見せる。見た目のクラスはすべて sm: 付きなので、
// sm 以上は従来と同じになる。
// isolate は全幅に付け、外枠を外したスマホでも中身の z-index を外枠の中に閉じ込める
// （sm 以上は backdrop-blur が同じ役目をしている）。外すと z-20 以上の要素が
// スクロール時に上部バー（z-20）の上に描かれてしまう。
const pageCardSurface =
  'isolate sm:border sm:border-white/70 sm:bg-white/85 sm:shadow-soft sm:backdrop-blur-sm'

export const pageCardClasses = {
  /** 一覧・設定画面の外枠（角丸 28px・余白 28px） */
  regular: `${pageCardSurface} sm:rounded-[28px] sm:p-7`,
  /** 編集フォーム・詳細画面の外枠（角丸 32px・余白 32px） */
  large: `${pageCardSurface} sm:rounded-[32px] sm:p-8`,
}
